import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import styles from './Header.module.css';
import { useMediaQuery } from 'react-responsive';

export interface HeaderProps extends PropsWithChildren {
    title: string | JSX.Element;
    onClose?: () => void;
    onBack?: () => void;
    className?: string;
}

export const Header: FunctionComponent<HeaderProps> = props => {
    const isMobile = useMediaQuery({ query: '(max-width:600px)' });

    const backButton = (
        <div
            className={styles.backButton}
            onClick={props.onBack}
        >
            <FontAwesomeIcon
                icon={faArrowLeft}
                fontSize={24}
                color="#00000"
            />
        </div>
    );
    const closeButton = (
        <div
            className={styles.closeButton}
            onClick={props.onClose}
        >
            <FontAwesomeIcon
                icon={faTimes}
                fontSize={24}
                color="#00000"
            />
        </div>
    );

    return (
        <div className={clsx(styles.container, props.className)}>
            {props.onBack && backButton}
            <div className={styles.titleContainer}>
                <span className={styles.title}>{props.title}</span>
            </div>
            {props.children}
            {props.onClose && isMobile && closeButton}
        </div>
    );
};

export default Header;
